// SPDX-License-Identifier: MIT

// Loads the Google Tag Manager container from the plugin, gated behind consent,
// so GTM — and every tag it fires (GA4, Google Ads, and any Custom HTML pixels
// like Facebook/Bing) — doesn't load until the visitor opts in. Replaces loading
// GTM unconditionally via gatsby-plugin-google-tagmanager.
//
// Note: this controls WHEN the container loads, not which of its tags fire once
// it does. Google tags still honor Consent Mode per category; non-Google Custom
// HTML tags fire on container load, so gate GTM on the broadest category those
// tags belong to (marketing), or give them per-tag consent checks in GTM.

const GTM_FLAG = '__ccGtmLoaded';

// Injects the standard GTM snippet once (guarded). `defaultDataLayer` is an
// optional object pushed before gtm.js (same option name as
// gatsby-plugin-google-tagmanager).
const injectGtm = (id, defaultDataLayer) => {
  if (!id || typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window[GTM_FLAG]) return;
  window[GTM_FLAG] = true;

  window.dataLayer = window.dataLayer || [];
  if (defaultDataLayer) window.dataLayer.push(defaultDataLayer);
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtm.js?id=' + id;
  const first = document.getElementsByTagName('script')[0];
  if (first && first.parentNode) first.parentNode.insertBefore(s, first);
  else if (document.head) document.head.appendChild(s);
};

module.exports = { injectGtm, GTM_FLAG };
